function convertLocalTimes(root = document) {
  const timeElements = root.querySelectorAll('.local-time');
  timeElements.forEach(function(element) {
    const utcTime = element.getAttribute('data-utc');
    if (utcTime) {
      const date = new Date(utcTime);
      const localTime = date.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
      element.textContent = localTime;
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Применяем локализацию времени при первой загрузке
  convertLocalTimes(document);

  // Весь функционал фильтров/поиска/пагинации — только на странице звонков
  const form = document.getElementById('calls-filters-form');
  if (!form) return;

  const dataWrapId = 'calls-data';
  const exportLink = form.querySelector('a[href*="export=1"]');

  // Автосабмит (поиск без кнопки) + дебаунс для поля телефона
  let debounceTimer;
  const submitForm = () => form.requestSubmit ? form.requestSubmit() : form.submit();

  form.querySelectorAll('[data-autosubmit]').forEach(el => {
    const mode = el.getAttribute('data-autosubmit');
    if (mode === 'debounce') {
      el.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => submitForm(), 300);
      });
    } else {
      el.addEventListener('change', submitForm);
      el.addEventListener('input', (e) => {
        if (e.key === 'Enter') submitForm();
      });
    }
  });

  const buildUrlFromForm = (keepPage = false) => {
    const params = new URLSearchParams(new FormData(form));
    if (!keepPage) params.delete('page');
    return `${location.pathname}?${params.toString()}`;
  };

  const refreshExportHref = () => {
    if (!exportLink) return;
    const params = new URLSearchParams(new FormData(form));
    params.set('export', '1');
    exportLink.href = `${location.pathname}?${params.toString()}`;
  };

  const replaceDataHTML = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const next = doc.getElementById(dataWrapId);
    const cur = document.getElementById(dataWrapId);
    if (next && cur) {
      cur.replaceWith(next);
      // Применяем локализацию времени к новому блоку
      convertLocalTimes(next);
    }
  };

  const ajaxUpdate = async (keepPage = false) => {
    // Сохраняем фокус/позицию каретки для активного поля формы
    const active = document.activeElement;
    const isInput = active && active.tagName === 'INPUT' && active.form === form;
    const name = isInput ? active.name : null;
    const sel = isInput && typeof active.selectionStart === 'number' ? { s: active.selectionStart, e: active.selectionEnd } : null;

    try {
      const url = buildUrlFromForm(keepPage);
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const text = await res.text();
      replaceDataHTML(text);
      history.replaceState(null, '', url);
      refreshExportHref();

      if (name) {
        const target = form.querySelector(`[name="${name}"]`);
        if (target) {
          target.focus();
          if (typeof target.setSelectionRange === 'function') {
            if (name === 'phone') {
              // Для поля телефона всегда ставим курсор в конец,
              // иначе возможны скачки каретки на предпоследнюю позицию
              const end = target.value.length;
              target.setSelectionRange(end, end);
            } else if (sel) {
              const end = Math.min(target.value.length, sel.e);
              target.setSelectionRange(end, end);
            }
          }
        }
      }
    } catch (e) {
      // Безопасный фоллбек — ничего не делаем
    }
  };

  // Перехватываем submit формы (включая автосабмит)
  form.addEventListener('submit', function(ev) {
    ev.preventDefault();
    ajaxUpdate(false);
  });

  // Перехватываем клики по пагинации внутри блока данных
  document.addEventListener('click', function(e) {
    const a = e.target.closest('a');
    if (!a) return;
    if (a.closest(`#${dataWrapId}`) && a.getAttribute('href') && a.getAttribute('href').includes('page=')) {
      e.preventDefault();
      const url = new URL(a.href, location.origin);
      fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(r => r.text())
        .then(text => {
          replaceDataHTML(text);
          history.replaceState(null, '', url.toString());
        })
        .catch(() => { location.href = a.href; });
    }
  });

  // Изначально привести ссылку Экспорт к текущему состоянию формы
  refreshExportHref();
});